import React from 'react'
import SvgIcon from 'Components/SvgIcon'

import { _EstimateAnimation, _Lightning, _Circle } from './styles'

const EstimateAnimation = () => (
  <_EstimateAnimation>
    <_Lightning>
      <SvgIcon name="#icon-estimate-lightning" width="100%" />
    </_Lightning>
    <_Circle />
  </_EstimateAnimation>
)


export default EstimateAnimation
